import React from "react";
import { Outlet } from "react-router-dom";

const Supplier: React.FC = () => {
  return <Outlet />;
};

export default Supplier;